import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'ui-components/components/button';
import { ChildrenPropType } from '../../../../../prop-types/children';
import { ADD_FUNDS } from '../../constants/fund-type';
import { useAddFundsContext } from '../../context/add-funds-context-provider';
import { useTrackEvent, PageEvents } from '../../hooks/use-track-event';
import { useFundLimitRemaining } from '../../../../../hooks/account-information/use-fund-limit-remaining';
import { MINIMUM_PURCHASE_AMT } from '../constants/add-funds-constants';

const SubmitButton = ({ children, fundType = ADD_FUNDS, disabled = false, trackingId }) => {
  const {
    autoFundEnabled,
    balanceThreshold,
    autoFundAmount,
    maxDailyFundings,
    updateAutoFundsConfig,
    purchaseFunds,
    fundAmount,
    useAsDefault,
    submitting,
    setSubmitting,
    currencyCode,
  } = useAddFundsContext();

  const trackSaveAutofundClick = useTrackEvent(PageEvents.MANAGE_AUTOFUND_CONFIG_SAVE);
  const trackAddFundsClick = useTrackEvent(PageEvents.CONFIRM_FUND_WALLET_CLICK);

  const limitRemaining = useFundLimitRemaining();
  const isLimitRemainingLessThanMinimum = limitRemaining < MINIMUM_PURCHASE_AMT;

  const buttonIsDisabled = submitting || disabled || isLimitRemainingLessThanMinimum || fundAmount > limitRemaining;

  const onSubmit = async () => {
    setSubmitting(true);
    if (fundType === ADD_FUNDS) {
      trackAddFundsClick({ fundAmount, currencyCode, useAsDefault });
      await purchaseFunds(useAsDefault, fundAmount, trackingId);
      setSubmitting(false);
      return;
    }

    trackSaveAutofundClick({
      autoFundEnabled,
      balanceThreshold,
      autoFundAmount,
      maxDailyFundings,
    });
    await updateAutoFundsConfig(autoFundEnabled, balanceThreshold, autoFundAmount, maxDailyFundings);
    setSubmitting(false);
  };

  return (
    <Button disabled={buttonIsDisabled} onClick={onSubmit} theme='primary'>
      {children}
    </Button>
  );
};

SubmitButton.propTypes = {
  children: ChildrenPropType.isRequired,
  fundType: PropTypes.string,
  disabled: PropTypes.bool,
  trackingId: PropTypes.string.isRequired,
};

export default SubmitButton;
